import { proxyCustomElement, HTMLElement, createEvent, h, Fragment } from '@stencil/core/internal/client';
import { d as defineCustomElement$4 } from './button.js';
import { d as defineCustomElement$3 } from './icon.js';
import { d as defineCustomElement$2 } from './spinner.js';

const paginationCss = ".tt-pagination-component{padding:1rem;display:flex;justify-content:center;align-items:center;column-gap:0.125rem}.tt-pagination-component .tt-pagination-ellipsis{width:2rem;flex-shrink:0;align-self:center;text-align:center}";

const Pagination = /*@__PURE__*/ proxyCustomElement(class extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
    this.ttChange = createEvent(this, "tt-change", 7);
    /** The number of pages in the start and end section of the pagination component */
    this.cornerCount = 5;
    this.handlePageClick = (event) => {
      const page = Number(event.target.value);
      this.value = page;
      this.ttChange.emit({ value: page });
    };
    this.handleClickBack = () => {
      this.value -= 1;
      this.ttChange.emit({ value: this.value });
    };
    this.handleClickForward = () => {
      this.value += 1;
      this.ttChange.emit({ value: this.value });
    };
    this.pageCount = undefined;
    this.value = 1;
  }
  connectedCallback() {
    this.handlePageClick = this.handlePageClick.bind(this);
    this.handleClickBack = this.handleClickBack.bind(this);
    this.handleClickForward = this.handleClickForward.bind(this);
  }
  render() {
    const reducedArray = Array.from({ length: this.pageCount }, (_, i) => i + 1).reduce((ps, p) => {
      if ((this.value < this.cornerCount && p <= this.cornerCount) ||
        (this.value > this.pageCount - this.cornerCount + 1 && p > this.pageCount - this.cornerCount) ||
        p === 1 ||
        p === this.pageCount ||
        Math.abs(p - this.value) <= 1) {
        ps.push(p);
        return ps;
      }
      return ps;
    }, []);
    return (h("div", { class: "tt-pagination-component" }, h("tt-button", { class: "tt-pagination-chevron", onClick: this.handleClickBack, disabled: this.value === 1, circle: true, variant: "ghost", color: "secondary", size: "small" }, h("tt-icon", { library: "one", name: "chevron-left" })), reducedArray.map((i, idx, array) => (h(Fragment, null, array[idx] - array[idx - 1] > 1 && h("div", { class: "tt-pagination-ellipsis" }, "..."), h("tt-button", { circle: true, key: i, variant: this.value === i ? 'light' : 'ghost', onClick: this.handlePageClick, color: "secondary", size: "small", value: `${i}` }, i)))), h("tt-button", { class: "tt-pagination-chevron", disabled: this.value === this.pageCount, onClick: this.handleClickForward, label: "forward-chevron", circle: true, variant: "ghost", color: "secondary", size: "small" }, h("tt-icon", { library: "one", name: "chevron-right" }))));
  }
  get element() { return this; }
  static get style() { return paginationCss; }
}, [1, "tt-pagination", {
    "pageCount": [2, "page-count"],
    "value": [2]
  }]);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["tt-pagination", "tt-button", "tt-icon", "tt-spinner"];
  components.forEach(tagName => { switch (tagName) {
    case "tt-pagination":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, Pagination);
      }
      break;
    case "tt-button":
      if (!customElements.get(tagName)) {
        defineCustomElement$4();
      }
      break;
    case "tt-icon":
      if (!customElements.get(tagName)) {
        defineCustomElement$3();
      }
      break;
    case "tt-spinner":
      if (!customElements.get(tagName)) {
        defineCustomElement$2();
      }
      break;
  } });
}

const TtPagination = Pagination;
const defineCustomElement = defineCustomElement$1;

export { TtPagination, defineCustomElement };
